import { PGA_COM_HOST } from 'env'

export const countActiveOfferings = lessonTypes =>
  (lessonTypes || []).filter(
    ({ status, deletedAt }) => status === 'ACTIVE' && !deletedAt,
  ).length

export const formatLocationLine = ({ city, state, offeringsCount }) => {
  const location = [city, state].filter(Boolean).join(', ')
  const offeringsLabel = `${offeringsCount} offering${
    offeringsCount === 1 ? '' : 's'
  }`

  if (!location) {
    return offeringsCount ? offeringsLabel : null
  }

  return offeringsCount ? `${location} · ${offeringsLabel}` : location
}

export const getActiveLessonPacks = lessonCreditBalances => {
  if (!lessonCreditBalances?.length) {
    return []
  }

  return [...lessonCreditBalances].sort(
    (left, right) => right.remainingCredits - left.remainingCredits,
  )
}

export const getPrimaryLessonPack = lessonCreditBalances =>
  getActiveLessonPacks(lessonCreditBalances)[0] || null

export const buildLessonPackBookingUrl = lessonPack => {
  const { lessonType, remainingCredits } = lessonPack
  const locationId = lessonType.locations?.[0]?.id
  const bookingUrl = lessonType.coach?.bookingUrl

  if (!bookingUrl || !locationId) {
    return null
  }

  const coachSlug = bookingUrl.match(/\/coach\/([^/?]+)/)?.[1]
  if (!coachSlug) {
    return null
  }

  return (
    `/coach/${coachSlug}/schedule` +
    `?lessonTypeId=${lessonType.id}&locationId=${locationId}` +
    `&lessonCreditBalanceQuantity=${remainingCredits}`
  )
}

export const buildCoachProfileUrl = ({ coachSlug, externalId }) => {
  const idOrSlug = coachSlug || externalId

  if (!idOrSlug) {
    return null
  }

  return `${PGA_COM_HOST}/coach/${idOrSlug}`
}

export const buildGoogleMapsUrl = ({ facilityName, city, state }) => {
  const query = [facilityName, city, state].filter(Boolean).join(', ')

  if (!query) {
    return null
  }

  return `https://maps.google.com/?q=${encodeURIComponent(query)}`
}

export const formatLessonPackRemaining = remainingCredits =>
  `${remainingCredits} lesson${remainingCredits === 1 ? '' : 's'} remaining`

export const formatLessonPackSummary = (remainingCredits, title) =>
  `${remainingCredits} lesson${
    remainingCredits === 1 ? '' : 's'
  } left on ${title}`
